module.exports = __webpack_public_path__ + "static/media/ShareLink.d5b35207.svg";